/** @format */

import { useSafeTranslate } from '@hooks/use-safe-translate';
import React from 'react';

interface TranslateTextProps {
  useJson?: boolean;
  htmlTag?: string;
  optionValue?: string;
  children?: string;
}

const Translate = (props: TranslateTextProps): JSX.Element => {
  const { useJson, htmlTag, optionValue, children } = props;
  const translatedText = useSafeTranslate(children, useJson);
  if (!translatedText) return <></>;

  if (htmlTag === 'option') {
    return (
      <option key={children} value={optionValue}>
        {translatedText}
      </option>
    );
  }

  return <>{translatedText}</>;
};

export default Translate;
